export default __webpack_public_path__ + "static/media/RotaryMotionImg.114923f8.jpg";